var _rect, _rect2, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChatCaseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 39,
    viewBox: "0 0 26 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 6,
    width: 19,
    height: 31,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 12,
    width: 16,
    height: 10,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.1328 30.5511H2.66344V6.30622H20.1328V12.5001H22.5002V3.12255C22.5002 1.40826 21.1124 0.0205078 19.3981 0.0205078H3.43896C1.72467 0.0205078 0.336914 1.40826 0.336914 3.12255V35.694C0.336914 37.4083 1.72467 38.796 3.43896 38.796H19.3981C21.1124 38.796 22.5002 37.4083 22.5002 35.694V21.0001H20.1328V30.5511ZM8.09202 2.67357H14.7043C15.0716 2.67357 15.3981 2.95928 15.3981 3.36745C15.3981 3.73479 15.1124 4.06132 14.7043 4.06132H8.09202C7.72467 4.06132 7.39814 3.77561 7.39814 3.36745C7.43896 2.95928 7.72467 2.67357 8.09202 2.67357ZM11.3981 36.2654C10.4185 36.2654 9.64304 35.4899 9.64304 34.5103C9.64304 33.5307 10.4185 32.7552 11.3981 32.7552C12.3777 32.7552 13.1532 33.5307 13.1532 34.5103C13.1532 35.4491 12.3777 36.2654 11.3981 36.2654Z",
    fill: "#5A52C3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9077 11.5308H9.27509C8.66285 11.5308 8.21387 12.0206 8.21387 12.592V21.694C8.21387 22.3063 8.70366 22.7553 9.27509 22.7553H11.1526V25.6124C11.1526 26.4695 12.2139 26.9185 12.7853 26.3063L16.3363 22.7553H24.9077C25.52 22.7553 25.969 22.2655 25.969 21.694V12.592C26.0098 12.0206 25.52 11.5308 24.9077 11.5308ZM12.4996 18.5104C11.7649 18.5104 11.1526 17.8981 11.1526 17.1634C11.1526 16.4287 11.7649 15.8165 12.4996 15.8165C13.2343 15.8165 13.8465 16.4287 13.8465 17.1634C13.8465 17.8981 13.2343 18.5104 12.4996 18.5104ZM17.1118 18.5104C16.3771 18.5104 15.7649 17.8981 15.7649 17.1634C15.7649 16.4287 16.3771 15.8165 17.1118 15.8165C17.8465 15.8165 18.4588 16.4287 18.4588 17.1634C18.4179 17.8981 17.8465 18.5104 17.1118 18.5104ZM21.6833 18.5104C20.9486 18.5104 20.3363 17.8981 20.3363 17.1634C20.3363 16.4287 20.9486 15.8165 21.6833 15.8165C22.4179 15.8165 23.0302 16.4287 23.0302 17.1634C23.0302 17.8981 22.4179 18.5104 21.6833 18.5104Z",
    fill: "#5A52C3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatCaseIcon);
export default __webpack_public_path__ + "static/media/chatCaseIcon.690e79ef22db790ca76a863594a05e42.svg";
export { ForwardRef as ReactComponent };